module.exports = "/_next/static/images/analytics-3132938cb5a3e14e5f7f0ea1071aa8a7.png";